import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Text } from '../../new-libby/core/typography';
export var PageContainer = function (props) {
    var classNames = namespacedClassnames(compKey, props.className);
    return (React.createElement("div", { className: classNames },
        React.createElement("div", { className: 'page-content' },
            React.createElement("div", { className: 'page-titles' },
                React.createElement(Text, { className: 'title', type: 'hsm', color: 't20' }, props.title),
                React.createElement(Text, { className: 'description', type: 'hxs', color: 't30' }, props.description)),
            React.createElement("div", null, props.children))));
};
//# sourceMappingURL=index.js.map